import { call, put, takeEvery } from "redux-saga/effects";
import { getScreenDetailsFail, getScreenDetailsSuccess } from "./actions";

import { getCall } from "../../../../helpers/fakebackend_helper";
import { verifyData } from "../../../../pages/Common/CommonFunctions/commonFunctions";
import { GET_ALL_SCREEN_DETAILS } from "./actionTypes";
// Worker Saga: Makes the API call and dispatches success or failure actions
function* fetchScreenDetails(data) {
  let requestData = data.payload;
  try {
    let url = "recruitment/screen";
    let pageNumeber = 0;
    let pageSize = 50;
    if (requestData !== undefined && requestData != null) {
      pageNumeber = requestData.pageNumber
        ? requestData.pageNumber
        : pageNumeber;
      pageSize = requestData.pageSize ? requestData.pageSize : pageSize;
    }
    url = url + `?page=${pageNumeber}&pageSize=${pageSize}`;
    if (requestData.sort !== null && requestData.sort !== undefined) {
      url = url + "&sort=" + encodeURIComponent(requestData.sort);
    }
    let extentedUrl;

    if (
      verifyData(requestData.filter) &&
      Object.entries(requestData?.filter).length > 0
    ) {
      extentedUrl = requestData.filter.map((eachObject) => {
        return (
          eachObject.filterName +
          "=" +
          encodeURIComponent(
            eachObject.condition + "[" + eachObject.value + "]"
          )
        );
      });
    }
    if (verifyData(requestData.searchKeyword)) {
      url = url + "&searchKeyword=" + requestData.searchKeyword;
    }
    if(extentedUrl !== undefined && extentedUrl !== null && extentedUrl !== ""){
        url = url+`&${extentedUrl.join("&") }`
      }
    
    const response = yield call(getCall, url);
    
    yield put(getScreenDetailsSuccess(response));
  } catch (error) {
    
    yield put(getScreenDetailsFail(error.message));
  }
}

function* screenDetailsSaga() {
  yield takeEvery(GET_ALL_SCREEN_DETAILS, fetchScreenDetails);
}
export default screenDetailsSaga;
